import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import { Convert } from 'src/helpers';
import { ThemeModal } from 'src/components';
import { IMAGES } from 'src/constants';
import styles from './_desktopSipTransactionsSuccess.module.scss';

class DesktopSipTransactionsSuccess extends Component {
  render() {
    const { checkoutDetail, status, history } = this.props;
    const isSuccess = status === 'success';
    return (
      <div className={styles['sip']}>
        <ThemeModal
          show
          title={checkoutDetail?.oneClickCheckout?.fundName}
          logo={checkoutDetail?.oneClickCheckout?.partner?.logo || IMAGES.MOTILAL_OSWAL}
          isBack
        >
          <div className={styles['mobile-sip-transactions']}>
            <div className={styles['main-title']}>
              {isSuccess ? (
                <>
                  You have successfully setup your auto-save for <br />
                  {Convert.toCapitalizeLetters(
                    checkoutDetail?.oneClickCheckout?.partner?.name ||
                      checkoutDetail?.oneClickCheckout?.amcName,
                  )}
                </>
              ) : (
                <>Payment failed</>
              )}
            </div>
            <div
              className={cx(styles['green-check'], {
                [styles['failed-check']]: !isSuccess,
              })}
            >
              {isSuccess ? (
                <img src="/img/okay-icon.svg" alt="ok" />
              ) : (
                <img src="/images/failed.png" alt="failed" />
              )}
            </div>

            <div className={styles['dates']}>
              <div>Starting on: {checkoutDetail?.oneClickCheckout?.startDate}</div>
              <div>Ending on: {checkoutDetail?.oneClickCheckout?.endDate}</div>
            </div>
            <div className={styles['footer-spacer']} />
            {!isSuccess && (
              <div
                className={cx(styles['footer'], {
                  [styles['disabled-footer']]: false,
                })}
              >
                <button onClick={() => history.goBack()} disabled={false}>
                  RETRY
                </button>
              </div>
            )}
            <div className={styles['powered-by']}>powered by savvy</div>
          </div>
        </ThemeModal>
      </div>
    );
  }
}

export default withRouter(DesktopSipTransactionsSuccess);
